import { render, staticRenderFns } from "./ServiceDetail.vue?vue&type=template&id=7e2a49a2&scoped=true"
import script from "./ServiceDetail.vue?vue&type=script&lang=js"
export * from "./ServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./ServiceDetail.vue?vue&type=style&index=0&id=7e2a49a2&prod&lang=scss&scoped=true"
import style1 from "./ServiceDetail.vue?vue&type=style&index=1&id=7e2a49a2&prod&lang=scss"
import style2 from "./ServiceDetail.vue?vue&type=style&index=2&id=7e2a49a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2a49a2",
  null
  
)

export default component.exports